import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.scss';
import { Provider } from 'react-redux';

import Engine from 'client/classes/Engine';

import store from './state/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import config from './config';

console.log("Starting WorkLink v" + config.webViewVersion);

// ENGINE
Engine.getInstance().init().then(() =>
{
	Engine.getInstance().mainLoop();
});

// REACT
const container = document.getElementById('root');
if(container)
{
	const root = ReactDOM.createRoot(container);
	root.render(
		<React.StrictMode>
			<Provider store={store}>
				<App />
			</Provider>				
		</React.StrictMode>
	);
}
else
{
	console.error('Failed to find root element');
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
